import es from './messages/es'
import en from './messages/en'
export default {
	es,
	en,
}
